export const environment = {
  production: false,
  apiUrl: "https://developer.api.us.stg.walmart.com/api-proxy/service/store/memberally/v1",
  consumerId: "4ff6f540-b891-4cff-a267-cd13ff9ef44d",
  pingFedUrl: "https://pfeddev.wal-mart.com/as/authorization.oauth2?client_id=MemberAllyApp&response_type=code&redirect_uri=https://dev.memberally.prod.us.walmart.net/authservice/webapp&scope=openid profile wire full"
};
